


<div class="card-info" *ngFor="let item of articles">
    <a href="javascript:void(0)" (click)="getSingleArticle(item.id)">
        <h3>{{item.title}}</h3>
        <div [innerHTML]="item.article | truncate:[300, '...']"></div>
        <div class="tags"><span *ngFor="let tag of item.tags | split:[',']" [textContent] = "tag"></span></div>
    </a>
    <!--<div class="button-read"><button class="btn-read" (click)="getSingleArticle(item.id)">Read More</button></div>-->
</div>
